import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { StandardLayout } from '../StandardLayout'
import styles from './SideNavLayout.scss'
import cx from 'classnames'
import { NavCollapseContext, NavToggleCollapseContext } from './SideNavContexts'
import { trackEvent } from 'lib/trackEvent'
import { setPreference } from 'lib/api/currentUser'
import { CONTENT_COLLAPSE_WIDTH } from 'lib/layoutConstants'

// Please see https://github.com/ridewithgps/rwgps-ui/pull/1328 for
// the full context on how we chose these threshold values for collapse
// behavior
const DASH_COLLAPSE = 'collapse_user_dashboard'

class _SideNavLayout extends React.PureComponent {
  constructor (props) {
    super(props)
    const { currentUser } = props
    this.state = {
      currentUser: currentUser,
      userCollapse: (currentUser.id && currentUser.preferences.get(DASH_COLLAPSE)) || false, // user has collapsed the nav in desktop mode
      viewportCollapse: window.innerWidth <= CONTENT_COLLAPSE_WIDTH, // render the nav in "mobile mode" due to a narrow viewport
      mobileNavExpanded: false // user has expanded the nav in mobile mode
    }
  }

  componentDidMount () {
    this._mediaquery = window.matchMedia(`screen and (max-width: ${CONTENT_COLLAPSE_WIDTH}px)`)
    this._mediaquery.addListener(this.onViewportCollapseBreakpoint)
    this._removeHistoryListener = browserHistory.listen(this.onNavigationAction)
  }

  componentWillUnMount () {
    this._mediaquery.removeListener(this.onViewportCollapseBreakpoint)
    this._removeHistoryListener()
  }

  onViewportCollapseBreakpoint = (e) => {
    this.setState({ viewportCollapse: window.innerWidth <= CONTENT_COLLAPSE_WIDTH, mobileNavExpanded: false })
  }

  onNavigationAction = () => {
    this.setState({ mobileNavExpanded: false })
  }

  toggleCollapse = (e) => {
    e && e.preventDefault()
    const { viewportCollapse } = this.state
    const { currentUser, setPreference } = this.props
    if (viewportCollapse) {
      // toggle mobile expand state
      this.setState({ mobileNavExpanded: !this.state.mobileNavExpanded })
    } else {
      // toggle desktop expand state
      currentUser.id && setPreference(DASH_COLLAPSE, !currentUser.preferences.get(DASH_COLLAPSE))
      trackEvent({ category: 'navigation', action: 'toggleSideNav', label: `Set nav expand state to userCollapse=${!this.state.userCollapse}` })
      this.setState({ userCollapse: !this.state.userCollapse })
    }
  }

  getCollapseState = () => {
    const { userCollapse, viewportCollapse, mobileNavExpanded } = this.state
    if (viewportCollapse) {
      return mobileNavExpanded ? 'viewport-expanded' : 'viewport'
    }
    if (userCollapse) {
      return 'user'
    }
    return false
  }

  render () {
    const { greybg, sidebarHeader, sidebarFooter, children, nav, ...props } = this.props

    const collapseState = this.getCollapseState()

    const topClassName = cx(
      styles.SideNavLayout,
      !collapseState && styles.notCollapsed,
      (collapseState === 'viewport' || collapseState === 'viewport-expanded') && styles.viewportCollapse,
      collapseState === 'user' && styles.userCollapse
    )

    return (
      <NavToggleCollapseContext.Provider value={this.toggleCollapse}>
        <NavCollapseContext.Provider value={collapseState}>
          <StandardLayout {...props}>
            <div className={topClassName}>
              {nav && <div className={styles.sidebar}>
                {React.cloneElement(nav, { collapseState })}
              </div>}
              {children && <div className={styles.content}>
                {Array.isArray(children)
                  ? children.filter(c => c).map(c => React.cloneElement(c, { collapseState }))
                  : React.cloneElement(children, { collapseState })}
              </div>}
            </div>
          </StandardLayout>
        </NavCollapseContext.Provider>
      </NavToggleCollapseContext.Provider>
    )
  }
}

const mapDispatchToProps = {
  setPreference
}

export const SideNavLayout = connect(
  state => ({ currentUser: state.currentUser }),
  mapDispatchToProps
)(_SideNavLayout)
